import { API_HOST, AXIOS_INSTANCE } from './api'

const SCHEDULES = "schedules";

export async function POST_SCHEDULE(form) {
	const response = await AXIOS_INSTANCE.post(`${API_HOST}/${SCHEDULES}`, form, {
		headers: {
			'Authorization': 'Bearer ' + window.localStorage.getItem('token')
		}
	});
	return response.data;
}

export async function LIST_SCHEDULES() {
    const response = await AXIOS_INSTANCE.get(`${API_HOST}/${SCHEDULES}`, {
      headers: {
        'Authorization': 'Bearer ' + window.localStorage.getItem('token')
      }
    });
    return response.data;
}


// WEBPACK FOOTER //
// ./src/services/schedule.js